import { render, staticRenderFns } from "./TextAutocomplete.vue?vue&type=template&id=423b29de&scoped=true"
import script from "./TextAutocomplete.vue?vue&type=script&lang=js"
export * from "./TextAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423b29de",
  null
  
)

export default component.exports